import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { PropType } from "vue";
import { Client } from "@/types";
import ClientCard from "@/components/pages/clients/ClientCard.vue";
import { useRouter } from "vue-router";
import { clientToSlug, clientToTo } from "@/tools/client";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientsList',
  props: {
    list: {
        type: Array as PropType<Client[]>,
        required: true,
    },
},
  setup(__props) {



const router = useRouter();

const selectClient = (client: Client) => {
    router.push(clientToTo(client));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (client) => {
      return (_openBlock(), _createElementBlock("li", {
        key: client.id
      }, [
        _createVNode(ClientCard, {
          client: client,
          onClick: ($event: any) => (selectClient(client))
        }, null, 8, ["client", "onClick"])
      ]))
    }), 128))
  ]))
}
}

})